import { useState, useRef, useEffect } from 'react';

const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Hoodies.html' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/T-Shirts.html' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Jackets.html' },
  { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Pants.html' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Headwear.html' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Sets.html' },
  { name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/search-918/name/Underwear.html' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Jersey.html' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Accessories.html' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Bags.html' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Belts.html' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Perfumes.html' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Other.html' },
];

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState('Browse Categories');
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (cat: typeof categories[0]) => {
    setSelected(cat.name);
    setIsOpen(false);
    window.open(cat.url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div ref={dropdownRef} className="relative w-full max-w-md mx-auto">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-5 py-3.5 bg-white border-2 border-background-200 rounded-xl text-foreground-800 text-sm font-medium cursor-pointer hover:border-accent-300 transition-colors duration-200"
      >
        <span className="truncate">{selected}</span>
        <span className={`w-5 h-5 flex items-center justify-center transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}>
          <i className="ri-arrow-down-s-line text-foreground-600"></i>
        </span>
      </button>
      {isOpen && (
        <div className="absolute z-50 mt-2 w-full bg-white border border-background-200 rounded-xl shadow-lg overflow-hidden max-h-80 overflow-y-auto">
          {categories.map((cat) => (
            <button
              key={cat.name}
              onClick={() => handleSelect(cat)}
              className="w-full text-left px-5 py-3 text-sm text-foreground-700 hover:bg-accent-50 hover:text-accent-800 cursor-pointer transition-colors duration-150 whitespace-nowrap border-b border-background-100 last:border-b-0"
            >
              {cat.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}